<template>
    <section class="section app-slider bg-light tw-pb-[160px]" id="app">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="title text-center pb-2">
                        <h6 class="mb-0 fw-bold text-primary">
                            App Looks like!
                        </h6>
                        <h2 class="f-40">App Screenshots!</h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12 mt-4 pt-2">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/1.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/2.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/3.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/4.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/5.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                            <div class="swiper-slide border-radius">
                                <img
                                    :src="
                                        require('@asset/landing/img/app_screenshots/6.png')
                                    "
                                    alt=""
                                    class="img-fluid"
                                />
                            </div>
                        </div>

                        <!-- navigation buttons -->
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
            <!-- end container -->
        </div>
    </section>
</template>

<script>
import Swiper from "@asset/landing/js/swiper.min.js";

export default {
    mounted() {
        new Swiper(".swiper-container", {
            loop: true,
            slidesPerView: 3,
            paginationClickable: true,
            pagination: ".swiper-pagination",
            slidesPerView: "auto",
            paginationClickable: true,
            spaceBetween: 0,
            centeredSlides: true,
            speed: 5000,
            autoplay: true,
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
            },
        });
    },
};
</script>
